<template>
  <path
    d="M12.4697 4.96967C12.7626 4.67678 13.2373 4.67678 13.5302 4.96967C13.8231 5.26257 13.8231 5.73734 13.5302 6.03022L8.53022 11.0302C8.23734 11.3231 7.76257 11.3231 7.46967 11.0302L2.46967 6.03022C2.17678 5.73732 2.17678 5.26256 2.46967 4.96967C2.76256 4.67678 3.23732 4.67678 3.53022 4.96967L7.99994 9.4394L12.4697 4.96967Z"
    fill="currentColor"
  />
</template>
